/* LoginPage.tsx generated by @compiled/babel-plugin v0.36.1 */
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./LoginPage.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { Box, Stack } from '@atlaskit/primitives/compiled';
import { useMemo, useState } from 'react';
import { useIntl } from 'react-intl-next';
import Heading from '@atlaskit/heading';
import Button from '@atlaskit/button/new';
import { ConfluenceLogo } from '@atlaskit/logo';
import { ExperienceStart } from '@atlassian/experience-tracker';
import { LoginToConfluenceIcon } from '../assets/LoginPageIconSVG';
import { ExperienceNames } from '../experience-tracker/ExperienceNames';
import RefreshBanner from './RefreshBanner';
import messages from './messages';
var fadeIn = null;
var styles = {
  loginButtonWrapper: "_19pkxy5q",
  parentDiv: "_1e0c1n7u _4cvr1h6o _6a6z1h6o",
  refreshBannerFade: "_ca0qv47k _u5f3v47k _n3tdv47k _19bvv47k _j7hq1wwu _5sagi11n"
};
var SUCCESS_URL_SUFFIX = '/wiki/embed/login-confirmation';
export var LoginPage = function LoginPage(_ref) {
  var contentId = _ref.contentId,
    reloadEP = _ref.reloadEP,
    spaceKey = _ref.spaceKey,
    url = _ref.url;
  var _useIntl = useIntl(),
    locale = _useIntl.locale,
    formatMessage = _useIntl.formatMessage;
  var loginUrl = useMemo(function () {
    var _window;
    var origin = url ? new URL(url).origin : (_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.origin;
    return "".concat(origin, "/login?application=confluence&dest-url=").concat(encodeURIComponent("".concat(SUCCESS_URL_SUFFIX, "?locale=").concat(locale)));
  }, [url, locale]);
  var handleClick = function handleClick() {
    openLoginPopup(loginUrl);
    setDisplayRefreshBanner(!displayRefreshBanner);
  };
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    displayRefreshBanner = _useState2[0],
    setDisplayRefreshBanner = _useState2[1];
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "login-page-test-id",
    className: ax([styles.parentDiv])
  }, /*#__PURE__*/React.createElement(ExperienceStart, {
    name: ExperienceNames.LOGIN_PAGE,
    id: "".concat(spaceKey, "-").concat(contentId)
  }), /*#__PURE__*/React.createElement(Stack, {
    space: "space.250",
    alignInline: "center"
  }, /*#__PURE__*/React.createElement(ConfluenceLogo, {
    size: "large",
    appearance: "brand"
  }), /*#__PURE__*/React.createElement(LoginToConfluenceIcon, null), /*#__PURE__*/React.createElement(Heading, {
    as: "h2",
    size: "large"
  }, formatMessage(messages.loginText))), /*#__PURE__*/React.createElement(Box, {
    xcss: styles.loginButtonWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    testId: "login-button",
    "aria-label": formatMessage(messages.loginAriaLabel),
    appearance: "primary",
    onClick: handleClick
  }, formatMessage(messages.loginButton))), displayRefreshBanner && /*#__PURE__*/React.createElement("div", {
    className: ax([styles.refreshBannerFade])
  }, /*#__PURE__*/React.createElement(RefreshBanner, {
    reloadEP: reloadEP,
    title: formatMessage(messages.refreshBanner),
    actionLabel: formatMessage(messages.refreshBannerLink)
  })));
};
function openLoginPopup(loginUrl) {
  var windowFeatures = 'popup=yes,left=100,top=100,width=640,height=640';
  window.open(loginUrl, '_blank', windowFeatures);
}